import React from 'react';
import { Link } from 'react-router-dom';
import { Flame, Snowflake } from 'lucide-react';

const ServicesSection = () => {
  return (
    <section className="py-10 md:py-12 lg:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-12">
          <span className="text-indigo-900 font-bold text-sm uppercase tracking-wider">Our Services</span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-indigo-900 mt-3 mb-4 md:mb-5">
            Residential & Commercial<br />HVAC Services
          </h2>
          <p className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto">
            While the other HVAC companies focus on plumbing, electrical, even roofing we pride ourselves on being an expert at two things: Heating & Cooling your home.
          </p>
        </div>

        {/* Two Large Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8">
          {/* Heating Card */}
          <Link to="/services/heating" className="group relative overflow-hidden rounded-xl md:rounded-2xl aspect-[4/3]" data-testid="service-card-heating">
            <img 
              src="/images/assets/heating.png"
              alt="Bryant Heating furnace system"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <h3 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white tracking-wider uppercase">HEATING</h3>
            </div>
          </Link>

          {/* Air Conditioning Card */}
          <Link to="/services/cooling" className="group relative overflow-hidden rounded-xl md:rounded-2xl aspect-[4/3]" data-testid="service-card-cooling">
            <img 
              src="/images/assets/ac.png"
              alt="Bryant Air conditioning unit"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <h3 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white tracking-wider uppercase">AIR CONDITIONING</h3>
            </div>
          </Link>
        </div>

        {/* Service Buttons Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {/* Heating Services */}
          <Link to="/services/heating/furnace-repair" className="bg-indigo-900 hover:bg-indigo-800 text-white rounded-xl p-4 md:p-5 text-center transition-colors" data-testid="btn-furnace-repair">
            <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-2 md:mb-3 border-2 border-white/30 rounded-full flex items-center justify-center">
              <Flame className="w-5 h-5 md:w-6 md:h-6" />
            </div>
            <span className="font-medium text-xs md:text-sm">Furnace<br />Repair</span>
          </Link>
          
          <Link to="/services/heating/furnace-replacement" className="bg-indigo-900 hover:bg-indigo-800 text-white rounded-xl p-4 md:p-5 text-center transition-colors" data-testid="btn-furnace-replacement">
            <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-2 md:mb-3 border-2 border-white/30 rounded-full flex items-center justify-center">
              <Flame className="w-5 h-5 md:w-6 md:h-6" />
            </div>
            <span className="font-medium text-xs md:text-sm">Furnace<br />Replacement</span>
          </Link>
          
          <Link to="/services/heating/furnace-maintenance" className="bg-indigo-900 hover:bg-indigo-800 text-white rounded-xl p-4 md:p-5 text-center transition-colors" data-testid="btn-furnace-maintenance">
            <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-2 md:mb-3 border-2 border-white/30 rounded-full flex items-center justify-center">
              <Flame className="w-5 h-5 md:w-6 md:h-6" />
            </div>
            <span className="font-medium text-xs md:text-sm">Furnace<br />Maintenance</span>
          </Link>

          {/* AC Services */}
          <Link to="/services/cooling/ac-repair" className="bg-indigo-900 hover:bg-indigo-800 text-white rounded-xl p-4 md:p-5 text-center transition-colors" data-testid="btn-ac-repair">
            <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-2 md:mb-3 border-2 border-white/30 rounded-full flex items-center justify-center">
              <Snowflake className="w-5 h-5 md:w-6 md:h-6" />
            </div>
            <span className="font-medium text-xs md:text-sm">AC<br />Repair</span>
          </Link>
          
          <Link to="/services/cooling/ac-replacement" className="bg-indigo-900 hover:bg-indigo-800 text-white rounded-xl p-4 md:p-5 text-center transition-colors" data-testid="btn-ac-replacement">
            <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-2 md:mb-3 border-2 border-white/30 rounded-full flex items-center justify-center">
              <Snowflake className="w-5 h-5 md:w-6 md:h-6" />
            </div>
            <span className="font-medium text-xs md:text-sm">AC<br />Replacement</span>
          </Link>
          
          <Link to="/services/cooling/ac-maintenance" className="bg-indigo-900 hover:bg-indigo-800 text-white rounded-xl p-4 md:p-5 text-center transition-colors" data-testid="btn-ac-maintenance">
            <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-2 md:mb-3 border-2 border-white/30 rounded-full flex items-center justify-center">
              <Snowflake className="w-5 h-5 md:w-6 md:h-6" />
            </div>
            <span className="font-medium text-xs md:text-sm">AC<br />Maintenance</span>
          </Link>
        </div>

        {/* Additional Services Row - Larger Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mt-4 md:mt-6">
          <Link to="/services/air-quality" className="group relative overflow-hidden rounded-xl md:rounded-2xl aspect-[3/2]" data-testid="btn-air-quality">
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-900 to-indigo-800"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-5 md:p-6">
              <div className="w-16 h-16 md:w-20 md:h-20 border-2 border-white/30 rounded-full flex items-center justify-center mb-3 md:mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-8 h-8 md:w-10 md:h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl uppercase tracking-wider mb-2">Indoor Air Quality</h3>
              <p className="text-white/80 text-center text-sm md:text-base">Breathe cleaner, healthier air in your home</p>
            </div>
          </Link>
          
          <Link to="/services/installation" className="group relative overflow-hidden rounded-xl md:rounded-2xl aspect-[3/2]" data-testid="btn-air-balancing">
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-900 to-indigo-800"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-5 md:p-6">
              <div className="w-16 h-16 md:w-20 md:h-20 border-2 border-white/30 rounded-full flex items-center justify-center mb-3 md:mb-4 group-hover:scale-110 transition-transform">
                <svg className="w-8 h-8 md:w-10 md:h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </div>
              <h3 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl uppercase tracking-wider mb-2">Air Balancing</h3>
              <p className="text-white/80 text-center text-sm md:text-base">Optimize your system performance</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
